import { getTsrAdminToken, setTsrAdminToken } from '../auth/tsrAdminAuth';
import { apiPost, buildApiUrl } from './apiClient';

export const requestTsrAdminOtp = async () => apiPost('/tsr/admin/request-otp', {});

export const verifyTsrAdminOtp = async (otp) => {
  const response = await apiPost('/tsr/admin/verify-otp', { otp });
  if (response?.data?.token) {
    setTsrAdminToken(response.data.token);
  }
  return response;
};

export const validateTsrAdminSession = async () => {
  const token = getTsrAdminToken();
  if (!token) {
    return false;
  }
  try {
    const response = await fetch(buildApiUrl('/tsr/admin/session'), {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await response.json().catch(() => ({}));
    return response.ok && data.success;
  } catch {
    return false;
  }
};
